import { ArrowSoftLeft, ArrowSoftRight } from 'src/shared/design-system/Icon';
import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Colors, Spacing, Transition } from 'web-common/src/shared/styles';
import { ARROW_SIZE, BUTTON_SIZE } from './consts';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.SINGLE};
`;

export const ButtonContainer = styled.div<{ disabled: boolean }>`
  width: ${BUTTON_SIZE}px;
  height: ${BUTTON_SIZE}px;
  position: relative;
  cursor: ${({ disabled }) => (disabled ? 'unset' : 'pointer')};
  svg {
    transition: opacity ${Transition.Time.BASE} ease-in-out;
    ${ifProp(
      'disabled',
      css`
        opacity: 0.3;
      `
    )}
  }
`;
export const ScrollButton = styled.div<{ hasBackgroundColor?: boolean }>`
  width: ${BUTTON_SIZE}px;
  height: ${BUTTON_SIZE}px;
  border: 1.25px solid ${Colors.GRAY_LITE_20};
  border-radius: ${BUTTON_SIZE}px;

  background: ${({ hasBackgroundColor }) => (hasBackgroundColor ? Colors.GRAY_LITE_20 : Colors.WHITE)};
  opacity: ${({ hasBackgroundColor }) => (hasBackgroundColor ? '0.2' : '1')};

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ArrowRight = styled(ArrowSoftRight)`
  position: absolute;
  top: ${(BUTTON_SIZE - ARROW_SIZE) / 2}px;
  left: ${(BUTTON_SIZE - ARROW_SIZE) / 2}px;
`;

export const ArrowLeft = styled(ArrowSoftLeft)`
  position: absolute;
  top: ${(BUTTON_SIZE - ARROW_SIZE) / 2}px;
  left: ${(BUTTON_SIZE - ARROW_SIZE) / 2}px;
`;
